<template>
  <div class="center">
    <h1>{{ $t("form.termcondition_title") }}</h1>
    <div>
      <form @submit.prevent="handleSubmit(!v$.$invalid)" class="p-fluid">
        <ScrollPanel style="width: 100%; height: 300px" class="custombar1 mb-4">
          <p>
            {{ $t("form.termcondition_text") }}
          </p>
        </ScrollPanel>
        <div style="text-align: center">
          <ToggleButton
            v-model="v$.accept.$model"
            :onLabel="$t('form.confirm_agreement')"
            :offLabel="$t('form.reject_agreement')"
            onIcon="pi pi-check"
            offIcon="pi pi-times"
            style="width: 10em"
            id="accept"
            name="accept"
            :class="{ 'p-invalid': v$.accept.$invalid && submitted }"
          />
          <label
            for="accept"
            :class="{ 'p-error': v$.accept.$invalid && submitted }"
            v-if="v$.accept.$error && submitted"
            ><br />
            {{ $t("form.termcondition_title") }}</label
          >
        </div>
        <div class="field mt-4">
          <div class="p-float-label p-input-icon-right">
            <i class="pi pi-envelope" />
            <InputText
              id="email"
              v-model="v$.email.$model"
              :class="{ 'p-invalid': v$.email.$invalid && submitted }"
              aria-describedby="email-error"
            />
            <label
              for="email"
              :class="{ 'p-error': v$.email.$invalid && submitted }"
              >Email</label
            >
          </div>
          <span v-if="v$.email.$error && submitted">
            <span
              id="email-error"
              v-for="(error, index) of v$.email.$errors"
              :key="index"
            >
              <small class="p-error">{{ error.$message }}</small>
            </span>
          </span>
          <small
            v-else-if="
              (v$.email.$invalid && submitted) || v$.email.$pending.$response
            "
            class="p-error"
            >{{ $t("form.terms_and_conditions_email_error") }}</small
          >
        </div>
        <Button
          class="centered-hor mt-2"
          :label="$t('form.submit_label')"
          type="submit"
          :disabled="accept === false"
        />
      </form>
    </div>
  </div>
</template>

<script>
import { email, required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
export default {
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      submitted: false,
    };
  },
  validations() {
    return {
      email: {
        email,
      },
      accept: {
        required,
        checked: (value) => value === true,
      },
    };
  },
  computed: {
    email: {
      get() {
        return this.$store.state.form.email;
      },
      set(value) {
        this.$store.commit("form/email", value);
      },
    },
    accept: {
      get() {
        return this.$store.state.form.accept;
      },
      set(value) {
        this.$store.commit("form/accept", value);
      },
    },
  },
  methods: {
    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );
    },
    async handleSubmit(isFormValid) {
      this.submitted = true;
      isFormValid;
      if (!isFormValid) {
        return;
      }
      this.$store.commit("loader/activeLoader", true);
      let uuidv4 = this.uuidv4();
      let data = {
        terms_and_conditions: this.accept,
        username: this.email != "" && this.email != null ? this.email : uuidv4,
        email:
          this.email != "" && this.email != null
            ? this.email
            : uuidv4 + "@email.com",
        password: this.email != "" && this.email != null ? this.email : uuidv4,
        user_type: "data-form",
        role: 1,
      };
      await this.$store.dispatch("form/createuser", data);
      if (this.$store.getters["form/result"] === null) {
        data = {
          terms_and_conditions: this.accept,
          username: (this.email = uuidv4),
          email: (this.email = uuidv4 + "@email.com"),
          password: (this.email = uuidv4),
          user_type: "data-form",
        };
        await this.$store.dispatch("form/createuser", data);
      }
      this.$router.push("form");
    },
    resetForm() {
      this.email = "";
      this.accept = null;
      this.submitted = false;
    },
  },
};
</script>

<style scoped>
p {
  font-family: raleway, sans-serif;
  font-weight: 300;
  font-style: normal;
  font-size: 1rem;
  text-align: justify;
  color: black;
}

h1 {
  font-family: raleway, sans-serif;
  font-weight: 700;
  font-style: normal;
  color: black;
  font-size: 3rem;
  text-align: center;
}

.center {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.p-button {
  background-color: #21575e;
  border: 1px solid #21575e;
}

.p-togglebutton {
  background-color: #21575e;
  border: 1px solid #21575e;
}

.p-button.p-togglebutton.p-component.p-highlight {
  background-color: #21575e;
  border: 1px solid #21575e;
}

.p-button.p-togglebutton {
  background: #ffffff;
  border: 1px solid #ced4da;
}

.p-button:focus {
  box-shadow: 0 0 0 0.1rem rgba(33, 87, 94, 0.5);
}

.p-button:enabled:hover {
  background: rgba(33, 87, 94, 0.8);
  border: rgba(33, 87, 94, 0.8);
}

.p-inputtext:enabled:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem rgba(33, 87, 94, 0.5);
  border-color: #21575e;
}
.p-inputtext:enabled:hover {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem rgba(33, 87, 94, 0.5);
  border-color: #21575e;
}
</style>
